// Thin wrapper so tests can mock a hard reload (jsdom's location is unforgeable).
// The pending flag lets UI that surfaces between reload() and the new document
// (e.g. the ErrorBoundary during stale-build recovery) show a loader instead of
// an error flash; it resets naturally when the new document loads.
let reloadPending = false

export function isReloadPending() {
  return reloadPending
}

export function reloadPage() {
  reloadPending = true
  window.location.reload()
}
